export function Download(): React.JSX.Element {
  return (
    <svg
      fill="none"
      height="40"
      viewBox="0 0 40 40"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6212 2.17993V21.2567L25.0717 15.8062"
        stroke="#FF7700"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
      <path
        d="M19.6214 21.2566L14.1709 15.8062"
        stroke="#FF7700"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
      <path
        d="M3.23193 21.2205H10.4306C11.0509 21.2205 11.6059 21.5633 11.8834 22.1183L13.7933 25.938C14.3483 27.048 15.4746 27.7499 16.7152 27.7499H22.4774C23.718 27.7499 24.8443 27.048 25.3993 25.938L27.3091 22.1183C27.5866 21.5633 28.158 21.2205 28.7619 21.2205H35.879"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
      <path
        d="M11.426 6.74146C5.64752 7.59028 3.26428 10.9856 3.26428 17.9557V24.4851C3.26428 32.6469 6.52899 35.9116 14.6908 35.9116H24.4849C32.6466 35.9116 35.9113 32.6469 35.9113 24.4851V17.9557C35.9113 10.9856 33.5281 7.59028 27.7496 6.74146"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25781"
      />
    </svg>
  );
}
